import { useChartStyleJsonCache } from '@/composables/useChartStyleJsonCache';
import { parseSharpCharts2XML } from '@/composables/parseSharpCharts2XML';
import { fetchSharpCharts2XML } from '@/composables/fetchSharpCharts2XML';
import { extractStyleCacheId } from '@/utils/extractStyleCacheId';
import { ChartStyle } from '@/interfaces/chart';

export async function getSharpCharts2ChartStyle(styleCacheId: string): Promise<ChartStyle> {
  const { addEntryToChartStyleJsonCache, getChartStyleJsonFromCache } = useChartStyleJsonCache();

  try {
    const formattedStyleCacheId = extractStyleCacheId(styleCacheId);

    if (!formattedStyleCacheId) {
      throw new Error(`styleCacheId argument is invalid: ${typeof styleCacheId} ${styleCacheId}.`);
    }

    if (formattedStyleCacheId !== styleCacheId) {
      throw new Error(`styleCacheId argument is valid but incorrectly formatted: ${typeof styleCacheId} ${styleCacheId}.`);
    }

    let chartStyle = getChartStyleJsonFromCache(formattedStyleCacheId);

    if (chartStyle) {
      return chartStyle;
    }

    const xmlString = await fetchSharpCharts2XML(formattedStyleCacheId);

    if (!xmlString) {
      throw new Error(`No XML string returned for styleCacheId: ${formattedStyleCacheId}.`);
    }

    chartStyle = parseSharpCharts2XML(xmlString);

    addEntryToChartStyleJsonCache(formattedStyleCacheId, chartStyle);

    return chartStyle;
  } catch (e) {
    window.sc3WorkbenchLogger.error(`Error occurred while getting SharpCharts2 chart or ChartStyle JSON for styleCacheId: ${typeof styleCacheId} ${styleCacheId}.`, e);

    throw new Error(`Error occurred while getting SharpCharts2 chart or ChartStyle JSON for styleCacheId: ${typeof styleCacheId} ${styleCacheId}.`, { cause: e });
  }
}
